import { render, staticRenderFns } from "./LicenseInfoPanel.vue?vue&type=template&id=aff8c3d6&scoped=true"
import script from "./LicenseInfoPanel.vue?vue&type=script&lang=js"
export * from "./LicenseInfoPanel.vue?vue&type=script&lang=js"
import style0 from "./LicenseInfoPanel.vue?vue&type=style&index=0&id=aff8c3d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aff8c3d6",
  null
  
)

export default component.exports